export default "__VITE_ASSET__CobmJsrM__"